import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

export class MemberDetailsPayBalanceSetAmountService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data,
            } );

            // extract navActions from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const members = get( response, 'body.component.data.state.members', [] );
            const subtitle = get( response, 'body.component.structure.widgetConfig.subtitle', {} );
            const fields = get( response, 'body.component.structure.fields', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    members: members,
                    subtitle: subtitle,
                    fields: getVisibleItems( fields, visibility ),
                },
            };
            
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
